import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CEUMA_URL_API } from 'app/config';

export const UPLOAD_IMG_API_URL = CEUMA_URL_API + '/imagem/';

@Injectable()
export class UploadImagemService {

  private headers: HttpHeaders = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) { }

  public uploadImagem(
    anoVestibular: string,
    codigoVestibular: string,
    cpfUsuario: string,
    imgBase64: string,
    documentoNotas = null,
    imagemDocReferencia = null,
    imagemIdentReferencia = null,
    documentoVeracidadeInformacao=null): Promise<any> {

    const inputUpload = {
      anoVestibular: anoVestibular,
      codigoVestibular: codigoVestibular,
      cpf: cpfUsuario,
      imagem: imgBase64,
      documentoNotasRef: documentoNotas,
      imagemDocReferencia:imagemDocReferencia,
      imagemIdentReferencia: imagemIdentReferencia,
      documentoVeracidadeInformacao: documentoVeracidadeInformacao
    };

    return new Promise<any>((resolvido, rejeitado) => {
      this.http.post(UPLOAD_IMG_API_URL, inputUpload, { headers: this.headers })
        .subscribe(
          (resp: any) => {
            if (!resp || resp.codigo) {
              rejeitado({ erro: resp });
            } else {
              resolvido({ sucesso: true });
            }
          },
          err => {
            console.log(err);
            const resp = err.error;
            if (!resp || resp.codigo) {
              rejeitado({ erro: resp });
            } else {
              rejeitado({ erro: { mensagem: 'Ocorreu um erro ao tentar realizar o upload da imagem' } });
            }
          },
        );
    });
  }

}
